var FreeResize = require('./free'),
    Slice = Array.prototype.slice;

module.exports = {
    resizeStart: function() {
        
        FreeResize.resizeStart.apply(this, arguments);
        this.obox = this.el.getBBox(); // should make 'helper' object ... (and this would augment it)
        this.HANDLE_D = this.dragHandle.attr('r') * 2;

    },
    resizeMove: function() {
        var args = Slice.call(arguments);
        FreeResize.resizeMove.apply(this, args.concat( preTransformShapeOnMove ) );

        /** 
            * return true / false indicating whether to continue in the resize move 
            * mx, my are is the position of the mouse relative to the canvas
            * this block the flip/'reflection'
        */

        function preTransformShapeOnMove(mx, my) {
           
             if ( this.isEast && ( mx < this.obox.x + this.HANDLE_D ) ) return false;
             if ( this.isSouth && ( my < this.obox.y + this.HANDLE_D) ) return false;
             if ( !this.isEast && ( mx > this.obox.x2 - this.HANDLE_D) ) return false;
             if ( !this.isSouth && ( my > this.obox.y2 - this.HANDLE_D) ) return false;

             return true;
        }
    },
    resizeEnd: function() {
        FreeResize.resizeEnd.apply(this, arguments);
        this.obox = null;
        this.HANDLE_D = null;
    }

};





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/resizeFns/freeNoReflection.js
 ** module id = 205
 ** module chunks = 0
 **/